import { useFm } from '@web3/base-hooks';
import { useCallback } from 'react';

export enum ErrorCode {
  WSOT_DRAWN = 34001,
  WSOT_TASK_NOT_COMPLETED = 34002,
  WSOT_PROJECT_NOT_EXISTED = 34003,
  WSOT_Activity_NOT_EXISTED = 34004,
  WSOT_TASK_NOT_EXISTED = 34005,
  WSOT_ACTIVITY_TIME_INVALID = 34006,
  WSOT_REGISTER_ALREADY = 34010,
  WSOT_NOT_REGISTERED = 34011,
  WSOT_USER_BOUND = 34012,
  WSOT_WALLET_SIGN_ERROR = 34013,
  WSOT_POINT_NOT_ENOUGH = 34014,
  WSOT_WALLET_TYPE_ERROR = 34015,
  WSOT_WALLET_TYPE_NOT_EMAIL = 34016,
  WSOT_UNSUPPORT_ACCOUNT_TYPE = 34017,
}

export const useErrorCodes = () => {
  const fm = useFm();
  const queryErrorMsg = useCallback(
    (errorCode: ErrorCode) => {
      switch (+errorCode) {
        case ErrorCode.WSOT_DRAWN:
          return fm('AIDOL_34001');
        case ErrorCode.WSOT_TASK_NOT_COMPLETED:
          return fm('AIDOL_34002');
        case ErrorCode.WSOT_PROJECT_NOT_EXISTED:
          return fm('AIDOL_34003');
        case ErrorCode.WSOT_Activity_NOT_EXISTED:
          return fm('AIDOL_34004');
        case ErrorCode.WSOT_TASK_NOT_EXISTED:
          return fm('AIDOL_34005');
        case ErrorCode.WSOT_ACTIVITY_TIME_INVALID:
          return fm('AIDOL_34006');
        case ErrorCode.WSOT_REGISTER_ALREADY:
          return fm('AIDOL_34010');
        case ErrorCode.WSOT_NOT_REGISTERED:
          return fm('AIDOL_34011');
        case ErrorCode.WSOT_USER_BOUND:
          return fm('AIDOL_34012');
        case ErrorCode.WSOT_WALLET_SIGN_ERROR:
          return fm('AIDOL_34013');
        case ErrorCode.WSOT_POINT_NOT_ENOUGH:
          return fm('AIDOL_34014');
        case ErrorCode.WSOT_WALLET_TYPE_ERROR:
          return fm('AIDOL_34015');
        case ErrorCode.WSOT_WALLET_TYPE_NOT_EMAIL:
          return fm('AIDOL_34016');
        case ErrorCode.WSOT_UNSUPPORT_ACCOUNT_TYPE:
          return fm('AIDOL_TC2');
        default:
          return `${errorCode} unknown error`;
      }
    },
    [fm]
  );
  return {
    queryErrorMsg,
  };
};
